module.exports = __webpack_public_path__ + "img/header-img-sm.ebe78362.png";